import { IGlobalState } from '../../../Root/store/appReducer'

export const getCompanyStatistics = (state: IGlobalState) => state.statistics.companyStatistics
export const getStatisticsSelectedCompanyId = (state: IGlobalState) => state.statistics.selectedCompanyId
